<template>
<div>
	<v-container>
		<v-row>
			<v-col cols="3">
				<v-btn
					@click="callTest"
					color="primary"
					block>
					Call API test
				</v-btn>
			</v-col>
			<v-col cols="9">
			</v-col>
			<v-col cols="3">
				<v-btn
					@click="callTestMultiple"
					color="primary"
					block>
					Call API test multiple
				</v-btn>
			</v-col>
			<v-col cols="3">
				<v-text-field
					v-model="multipleCallsCount"
					single-line>
				</v-text-field>
			</v-col>
			<v-col cols="6">
			</v-col>
		</v-row>
	</v-container>
	<v-dialog v-model="multipleCallsDialog"
		max-width="600"
		persistent>
		<v-card>
			<v-card-title class="headline">
				Api ответил
			</v-card-title>

			<v-card-text>
				<v-row>
					<v-col cols="4">
						Номер
					</v-col>
					<v-col cols="4">
						Время с начала
					</v-col>
					<v-col cols="4">
						Время
					</v-col>
					<v-col cols="4">
						Ответ
					</v-col>
				</v-row>
				<v-row v-for="(line, i) in multipleCallsOutput" :key="i">
					<v-col cols="3">
						Ответ {{ i + 1 }}
					</v-col>
					<v-col cols="3">
						{{ line.time }}
					</v-col>
					<v-col cols="3">
						{{ line.timeDiff }}
					</v-col>
					<v-col cols="3">
						{{ line.response }}
					</v-col>
				</v-row>
			</v-card-text>

			<v-card-actions class="pa-4">
				<v-btn color="primary" @click="multipleCallsDialog = !multipleCallsDialog">
					Закрыть
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</div>
</template>

<style scoped>

</style>

<script>
	import {api} from '../../lib/api'
	import _ from 'lodash'

	export default {
		components: {
		},
		data: () => ({
			email: 'maxim.izmaylov@ifk-hm.com',
			multipleCallsOutput: [],
			multipleCallsCount: 5,
			multipleCallsDialog: false
		}),
		computed: {

		},
		created() {
			// this.checkRestricted()
			// this.checkDev()
		},
		mounted() {

		},
		methods: {
			// checkRestricted() {
			// 	api.post('admin/check_restricted')
			// 	.then(response => {
			// 		this.restricted = response.data.restricted
			// 	}, error => {})
			// },
			// checkDev() {
			// 	api.post('admin/check_dev')
			// 	.then(response => {
			// 		this.dev = response.data.dev
			// 	}, error => {})
			// },
			testEmail() {
				api.post('admin/test_mail', {
					to: this.email
				})
				.then(response => {
					this.$store.dispatch('dialogNotify', {
						title: 'Успешно',
						message: 'Письмо отправлено'
					})
				}, error => {})
			},
			callTest() {
				api.post('admin/test')
				.then(response => {
					this.$store.dispatch('dialogNotify', {
						title: 'Test Api ответил успешно',
						message: response.data.message
					})
				}, error => {})
			},
			callTestMultiple() {
				let date = new Date()
				let calls = this.multipleCallsCount
				let prevTime = 0
				this.multipleCallsOutput = []

				for(let i = 0; i < calls; i++) {
					api.post('admin/test', {
						number: i
					})
					.then(response => {
						let timeNow = new Date() - date
						this.multipleCallsOutput.push({
							response: response.data.success ? response.data.message : response.data.error,
							time: timeNow,
							timeDiff: timeNow - prevTime
						})
						prevTime = timeNow
					}, error => {})
				}

				this.multipleCallsDialog = true
			},
		}
	}
</script>
